import { render, staticRenderFns } from "./userRoleDetailCNA.vue?vue&type=template&id=415cd364&"
import script from "./userRoleDetailCNA.vue?vue&type=script&lang=js&"
export * from "./userRoleDetailCNA.vue?vue&type=script&lang=js&"
import style0 from "./userRoleDetailCNA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports